import React from "react";
import {Button} from "antd";
function CountdownButtonComp({countdown, onClick}) {
    const [time, setTime] = React.useState(0);
    const triggerOnClick = () => {
        onClick();
        setTime(countdown);
        const timer = setInterval(() => {
            setTime(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 16,
            }}>
            <Button
                style={{ backgroundColor: "#1890ff", borderColor: "#1890ff", color: "#fff" }}
                className="btn btn-primary"
                onClick={triggerOnClick}
                disabled={time > 0}
                data-testid="countdown-button"
            >
                {time > 0 ? `Tekrar Gönder (${time})` : "Tekrar Gönder"}
            </Button>
        </div>
    );
}

export const CountdownButton = React.memo(CountdownButtonComp);